import { render } from "./Switch.vue?vue&type=template&id=f52a1ed8&ts=true"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__